import { render, staticRenderFns } from "./housing-info.vue?vue&type=template&id=9260f87c&"
import script from "./housing-info.vue?vue&type=script&lang=js&"
export * from "./housing-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports